import React, {Component, Fragment} from 'react';
import SiteTypeSelection from "../SiteTypeSelection";
import * as H from "history";
import SchoolMenu from '../SchoolMenu';
import SchoolPageTitle from '../SchoolPageTitle';

interface CreateSiteChoicePageProps {
    history: H.History;
    match: {
        params: {
            tenantId: string,
            schoolCode: string
        }
    }
}

interface CreateSiteChoicePageState {
    tenantId: string;
    schoolCode: string;
}

export default class CreateSiteChoicePage extends Component<CreateSiteChoicePageProps,CreateSiteChoicePageState> {
    
    static displayName = CreateSiteChoicePage.name;

    constructor(props: Readonly<CreateSiteChoicePageProps>) {
        super(props);
        
        this.state = {
            tenantId: props.match.params.tenantId,
            schoolCode: props.match.params.schoolCode
        };
    }

    componentDidMount() {
    }
    
    
    private onTeamClicked = () => {
        this.props.history.push(`/manage/${this.state.tenantId}/${this.state.schoolCode}/create-site/teams`);
    }
    
    private onCommunicationClicked = () => {
        this.props.history.push(`/manage/${this.state.tenantId}/${this.state.schoolCode}/create-site/communication`);
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.match.params.tenantId} schoolCode={this.props.match.params.schoolCode} title="Site Creation Tool" reverse={true} />
                <SchoolMenu prefix="Create Site"/>
                <SiteTypeSelection onTeamClicked={this.onTeamClicked} onCommunicationClicked={this.onCommunicationClicked}/>
            </Fragment>
        );
    }
}